// The connection banner (HARDEN-pwa): while the browser reports no network, a warning pinned to
// the top of every screen says that what shows may be out of date and changes will not save; it
// goes away by itself when the network returns. `navigator.onLine` false is reliable (no
// network at all); true only means "maybe", which the API's own errors cover.
import { Notice } from "@companyos/ui";
import { WifiOffIcon } from "lucide-react";
import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void): () => void {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-2 z-toast flex justify-center px-4">
      <Notice
        role="status"
        tone="warning"
        icon={WifiOffIcon}
        className="pointer-events-auto w-full max-w-md shadow-lg"
        data-offline-banner=""
      >
        You're offline. What you see may be out of date, and changes won't save until you're back
        online.
      </Notice>
    </div>
  );
}
